module.exports = __webpack_public_path__ + "static/media/M009-account.ee73771f.svg";